import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';

class UserProfilePanel extends Component {
    constructor(props) {
        super();
        this.state = {
            user:[],
        };
        this.trasnfer = this.trasnfer.bind(this);
    }

    componentDidMount() {
        this.getUser()
    }

    getUser = async () => {
        const userId = window.location.pathname.split('/')[2]
        const userInfo = await axios.get(`/api/users/get/${userId}`)
        this.setState({user: userInfo.data} );
    }

    trasnfer(user){
        swal.fire({
            text: "¿Estás seguro que deseas transferir a "+this.state.user.name+" ?",
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.transferRights(this.state.user);
            }
        });
    }
    async transferRights (user){
        var url = `/api/users/transfer`;
        const res = await axios.post(url,{user:user, peopleId:this.props.peopleid}).then(res=>{
            swal.fire({
                text: "Se han transferido tus derechos",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-danger",
                },
                timer: 3000
            }).then(function(result) {
                location.reload()
            });
        });
    }
    render() {
        return (
        <>
            <button onClick={()=>{this.trasnfer( )} } href="http://127.0.0.1:8000/people/new" class="btn btn-success btn-sm font-weight-bolder px-5">
                Convertir en propietario
            </button>
        </>
        );
    }
}

export default UserProfilePanel;

if (document.getElementById('UserProfilePanel')) {
    ReactDOM.render(<UserProfilePanel />, document.getElementById('UserProfilePanel'));
}
